export default "/images/385d2203daa3775cd3840fd2741441de.jpg";